import JassEnum from './enum';

/**
 * type gametype
 */
export default class JassGameType extends JassEnum {}
